import axios from "axios";
import qs from 'qs';

let host_ori = window.location.origin == 'http://127.0.0.1' ? 'http://gm.wanyuhudong.cn' : window.location.origin;
// let host_ori ="http://gm.wanyuhudong.cn";
let api=host_ori + '/appi';
// let api='http://10.0.68.131:3000';
export default{
    name:'api',
    //获取项目列表
    getProjectList(para){
        return axios.get(`${api}/Login/ProjList?userInfo=${para}`)
    },
    //获取项目菜单
    getProjectMenu(item,para){
        return axios.get(`${api}/Login/Menu?Project=${item}&userInfo=${para}`)
    },
    //数据表头部数据
    getTableHead(url,para){
        return axios.post(`${api}/bin${url}/columns`,{userInfo:para});
    },
    //数据表内容
    getTableList(data,para){
        // alert(9)
        if(Object.prototype.toString.call(data) === '[object Object]'){
            return axios.post(api + data.JQ_GRID_LOAD,qs.stringify(para), {
                headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
        }
        if(typeof data=='string'){
            return axios.post(api + data,qs.stringify(para), {
                headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                }
            }) 
        }
    },
    //获取弹框的data
    getBoxData(data,para){
        return axios.post(api+data.URL_DATAS,qs.stringify(para), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },
    //导出数据
    exportData(data,para){
        return axios.post(api+data.URL_TOEXCEL,{userInfo:para})
    },
    //根据action数据中的函数渲染不同的页面
    actionFn(para){
        return axios.post(api+'/AnyQuery/Admin/Admin/tbl_action_data')
    },
    //删除数据
    delData(data,para){
        return axios.post(api+data.JQ_GRID_DEL,para)
    },
    //添加
    addSubmitData(data,para){
        if(Object.prototype.toString.call(data) === '[object Object]'){
            return axios.post(api+data.JQ_GRID_ADD,qs.stringify(para),{
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                } 
            })
        }
        if(typeof data=='string'){
            return axios.post(api+data,qs.stringify(para),{
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                } 
            }) 
        }
    },
    //修改
    editSubmitData(data,para){
        return axios.post(api+data.JQ_GRID_UPDATE,qs.stringify(para),{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            } 
        })
    },
    //设置权限获取数据
    getPermissionData(url,para){
       return axios.get(`${api+url}?userInfo=${para}`)
    },
    //危机逃脱-实时监控-服务器信息获取数据
    getServerInfo(url){
        return axios.get(api+url)
    },
    //获取单选按钮框中的头部数据
    getChoiceAppHead(url){
        return axios.get(api+url)
    },
    //获取单选按钮框中的列表数据
    getChoiceAppRows(url,para){
        return axios.get(api+url+para)
    },
    //根据默认主键id查询子表数据
    serchChildData(){

    },
    //危机逃脱 角色查询区服数据
    regional_service_data(url,para){
        return axios.post(api+url,para)
    },
    //危机逃脱 角色查询查询角色头
    search_sever(url,para){
        return axios.post(url,para)
    },
    //危机逃脱 角色查询查询角色体
    search_sever_body(url,para){
        return axios.post(url,qs.stringify(para),{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            } 
        })
    },
} 